// extracted by mini-css-extract-plugin
module.exports = {"post":"Post_post__q9bdd","avatar_contaner":"Post_avatar_contaner__2ieOc","avatar":"Post_avatar__1Kjm-"};